module.exports = __webpack_public_path__ + "img/DialogClose.a3c07eac.svg";